
export class TimetableEntry {
  id: number = 0;
  host: string = "";
  subtitle: string = "";
  maxAttendees: number = 0;
  roomId: number = 0;
  timeslotId: number = 0;
  title: string = "";
  type: 'INFO' | 'BREAK' | 'WORKSHOP' = 'WORKSHOP';
  online: boolean = false;
  attendeeCount?: number;
  furtherInformationUrl: string = '';
  notes: string = '';
  tagIds: number[] = [];

  public static createFromJson(input: any): TimetableEntry {
    const data = new TimetableEntry();
    data.fromJson(input);
    return data;
  }

  fromJson(input: any) {
    this.id = input["id"];
    this.host = input["host"];
    this.subtitle = input["subtitle"];
    this.maxAttendees = input["maxAttendees"];
    this.roomId = input["roomId"];
    this.timeslotId = input["timeslotId"];
    this.title = input["title"];
    this.type = input["type"];
    this.online = input["online"];
    this.attendeeCount = input["attendeeCount"];
    this.furtherInformationUrl = input["furtherInformationUrl"];
    this.notes = input["notes"] || '';
    if (input["tagIds"]) {
      for (const child of input["tagIds"]) {
        this.tagIds.push(child);
      }
    }
  }

  toJson(): any {
    return {
      id: this.id,
      host: this.host,
      subtitle: this.subtitle,
      maxAttendees: this.maxAttendees,
      roomId: this.roomId,
      timeslotId: this.timeslotId,
      title: this.title,
      type: this.type,
      online: this.online,
      attendeeCount: this.attendeeCount,
      furtherInformationUrl: this.furtherInformationUrl,
      notes: this.notes,
      tagIds: [...this.tagIds]
    };
  }
}
